import { sllrHttp } from 'http.js';

export const getPagesList = (payload) => {
  return sllrHttp.get(`/pages`, payload);
};

export const getPage = (id) => {
  return sllrHttp.get(`/pages/${id}`);
};

export const createPage = (payload) => {
  return sllrHttp.post(`/pages`, payload);
};

export const deletePage = (pageId) => {
  return sllrHttp.delete(`/pages/${pageId}`);
};

export const editPage = (id, payload) => {
  return sllrHttp.put(`/pages/${id}`, payload);
};

export const validateURL = (payload) => {
  return sllrHttp.post(`/pages/validate`, payload);
};
